import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SnackbarComponent } from '../../_modules/shared/_components/snackbar/snackbar.component';

@Injectable({
    providedIn: 'root',
})
export class SnackbarService {
    constructor(private snackBar: MatSnackBar) {}

    successSnackbar(message: string) {
        this.snackBar.openFromComponent(SnackbarComponent, {
            horizontalPosition: 'end',
            verticalPosition: 'top',
            duration: 5000,
            data: { message, type: 'success' },
            panelClass: 'snackbar-custom',
        });
    }

    errorSnackbar(message: string) {
        this.snackBar.openFromComponent(SnackbarComponent, {
            horizontalPosition: 'end',
            verticalPosition: 'top',
            duration: 7000,
            data: { message, type: 'error' },
            panelClass: 'snackbar-custom',
        });
    }

    errorFrom(error: any, fallback: string) {
        this.errorSnackbar(this.extractMessage(error) || fallback);
    }

    private extractMessage(error: any): string {
        const body = error?.error ?? error;
        const candidate =
            body?.message ??
            body?.error_description ??
            body?.data?.message ??
            (typeof body?.error === 'string' ? body.error : '') ??
            (typeof body === 'string' ? body : '');
        const text = (candidate || '').toString().trim();
        if (!text || text.startsWith('{') || text.startsWith('<')) {
            return '';
        }
        return text;
    }

    warningSnackbar(message: string, duration = 5000) {
        this.snackBar.openFromComponent(SnackbarComponent, {
            horizontalPosition: 'end',
            verticalPosition: 'top',
            duration,
            data: { message, type: 'warning' },
            panelClass: 'snackbar-custom',
        });
    }
}
